import { ExclamationCircleFilled } from "@ant-design/icons";
import { Modal, Col, Row, Button } from "antd";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
interface AddEditModall {
  name: React.ReactNode;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  form?: string;
  title: string;
  id?: string | number | undefined;
  isSaving?: boolean;
}
const AddEditModal = ({
  name,
  open,
  setOpen,
  form,
  title,
  id,
  isSaving,
}: AddEditModall) => {
  const [t] = useTranslation("common");
  const { id: urlId } = useParams();
  const isEdit = () => {
    return !!id || !!urlId;
  };
  return (
    <>
      <Modal
        closable={false}
        maskClosable={false}
        onCancel={() => setOpen(false)}
        open={open}
        centered
        footer={[
          <Button
            key="cancel-button"
            onClick={() => {
              setOpen(false);
            }}
            style={{
              color: "#1677FF",
              border: "1px solid #1677FF",
              marginInlineEnd: "auto",
              height: "40px",
            }}
          >{`${t("cancel")}`}</Button>,
          <Button
            key="confirm-button"
            form={form}
            htmlType="submit"
            style={{
              background: "#1677FF",
              color: "#fff",
              height: "40px",
              border: "none",
            }}
            onClick={() => setOpen(true)}
            disabled={isSaving}
          >
            {isSaving ? `${t("loading")}` : `${t("confirm")}`}
          </Button>,
        ]}
        title={
          <Row>
            <Col span={3}>
              <ExclamationCircleFilled
                style={{
                  color: "#FFBC39",
                  fontSize: "45px",
                  marginTop: "22px",
                }}
              />
            </Col>
            {isEdit() ? (
              <Col span={19}>
                <Col
                  style={{
                    fontSize: "32px",
                    color: "#212121",
                  }}
                >
                  {" "}
                  {t("Confirm Changes")}
                </Col>
                <Col
                  style={{
                    color: "#212121",
                    fontSize: "16px",
                  }}
                >
                  {t("please-confirm-saving-changes-to")}
                </Col>
                <Col
                  span={23}
                  style={{
                    fontSize: "15px",
                    color: "#212121",
                    wordWrap: "break-word",
                  }}
                >
                  {name}
                </Col>
              </Col>
            ) : (
              <Col
                span={19}
                style={{
                  fontSize: "32px",
                  color: "#212121",
                }}
              >
                {t("confirm-adding")}
                <Col
                  span={19}
                  style={{
                    fontSize: "16px",
                    color: "#212121",
                  }}
                >
                  {t("please-confirm-adding")} {title}
                </Col>
              </Col>
            )}
          </Row>
        }
      />
    </>
  );
};
export default AddEditModal;
